import RestService from '../services/rest';

async function getPurchasesFeedbackList(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/purchases/feedbacks?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

export default {
  getPurchasesFeedbackList,
};
